

















import Component, { mixins } from "vue-class-component";
import { ContentFeedType } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import WithUserTags from "@/mixins/WithUserTags";
import { CheckRole } from "@/lib/decorators";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";
import SelectUserTagsModal from "@/components/SelectUserTagsModal";
import CreatePostController from "./components/CreatePostController";

@Component({
  name: "CreatePost",
  components: { CreatePostController, SelectUserTagsModal },
})
export default class CreatePost extends mixins(WithUserTags) {
  public userId: string = "";

  public loading: boolean = false;

  public userTags: string[] = [];

  public showCreate = false;

  public postId: string = "";

  public type: ContentFeedType = "";

  @CheckRole("creator")
  public checkedRole!: boolean;

  get allowShowCreate() {
    return this.showCreate && !this.showSelectTags;
  }

  get showSelectTags() {
    return this.checkedRole && this.userTags.length === 0 && this.showCreate && config.featureTags;
  }

  set showSelectTags(value: boolean) {
    this.showCreate = value;
  }

  public onClose() {
    this.postId = "";
    this.userId = "";
    this.showCreate = false;
  }

  public async getData() {
    try {
      this.loading = true;
      this.userTags = config.featureTags ? await this.userTagsGetData() : [];
    } finally {
      this.loading = false;
    }
  }

  public async showCreatePost(data: { postId?: string; userId: string; type?: ContentFeedType }) {
    try {
      await this.getData();
    } finally {
      this.postId = data.postId || "";
      this.type = data.type || "";
      this.userId = data.userId;
      this.showCreate = true;
    }
  }

  public created() {
    emitter.on<any>(EVENTS.SHOW_CREATE_POST, this.showCreatePost);
    this.$once("hook:beforeDestroy", () => emitter.off<any>(EVENTS.SHOW_CREATE_POST, this.showCreatePost));
  }
}
